/* eslint-disable max-len */
import React from 'react';

const LogoDrawer = () => {
  return (
    <svg width="120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 432.58 224.95">
      <path
        fill="#fff"
        d="M113.73,212.68a4.35,4.35,0,0,1-2-3.73,10.19,10.19,0,0,1,.85-2.88l4.33-11.67q.48-1.68,2.76-1.68l1.21.48q17.43,9.62,35.24,9.62,15,0,20.93-2.11t5.89-8.48q0-6.14-7.15-10.34a72.62,72.62,0,0,0-17.32-7q-10.17-2.82-20.57-6.67a42.39,42.39,0,0,1-17.5-12q-7.11-8.11-7.1-20.39,0-17.44,13.29-25.74t31.45-8.3q14.56,0,33.81,4.45a3.33,3.33,0,0,1,2.16,3.25,11.78,11.78,0,0,1-.72,2.88l-3.61,12.87a2.25,2.25,0,0,1-1,1.45,2.87,2.87,0,0,1-1.51.48h-.48q-19.73-3.25-23.93-3.13A54.18,54.18,0,0,0,149,125.48c-3.65,1-6.25,2.18-7.82,3.66a15.11,15.11,0,0,0-3.24,4.09,8.21,8.21,0,0,0-.9,3.55q0,5.66,7.15,9.5a88.38,88.38,0,0,0,17.38,6.8q10.23,3,20.57,6.86A43,43,0,0,1,199.67,172a29.26,29.26,0,0,1,7.16,20q0,13.6-11.31,23.28T158,225Q132.73,225,113.73,212.68Z"
      />
      <path
        fill="#fff"
        d="M214.1,170.34V107.67a3.94,3.94,0,0,1,1.38-3.12,4.52,4.52,0,0,1,3.07-1.21h15a4.52,4.52,0,0,1,3.07,1.21,3.94,3.94,0,0,1,1.38,3.12v68.57q0,25.86,29.59,25.86a61.8,61.8,0,0,0,10.23-1c4-.67,7.29-1.34,9.86-2l3.73-1V107.67a3.94,3.94,0,0,1,1.38-3.12,4.56,4.56,0,0,1,3.07-1.21h15a4.52,4.52,0,0,1,3.06,1.21,4,4,0,0,1,1.39,3.12V215.33q0,3.49-18.59,6.55t-31,3.07q-26.58,0-39.15-12.63T214.1,170.34Z"
      />
      <path
        fill="#fff"
        d="M432.58,156.51v62.55a4.25,4.25,0,0,1-1.32,3.19,4.37,4.37,0,0,1-3.12,1.26h-15a4.58,4.58,0,0,1-3.07-1.2,4.11,4.11,0,0,1-1.38-3.25V150.62q0-25.87-29.47-25.87a65.48,65.48,0,0,0-10.23,1c-4,.64-7.33,1.28-10,1.92l-3.73,1.08v90.34a4.16,4.16,0,0,1-1.38,3.19,4.46,4.46,0,0,1-3.07,1.26h-15a4.55,4.55,0,0,1-3.06-1.2,4.09,4.09,0,0,1-1.39-3.25V111.4q0-3.48,18.65-6.55t30.91-3.07q26.58,0,39.16,12.69T432.58,156.51Z"
      />
      <path
        fill="#fff"
        d="M167.53,75.84V71.76q0-8.13,4.28-12.75c2.84-3.08,6.79-4.61,11.82-4.61a48.45,48.45,0,0,1,8.63.64.67.67,0,0,1,.46.69l-.31,2.1c0,.31-.27.47-.8.5a42,42,0,0,0-6.18-.73q-14.62,0-14.62,15.72v1Q170.81,90,185.43,90a38,38,0,0,0,6.18-.69c.51,0,.78.16.8.46l.31,2.1a.73.73,0,0,1-.46.73,51.4,51.4,0,0,1-8.63.61q-7.59,0-11.84-4.6T167.53,75.84Z"
      />
      <path
        fill="#fff"
        d="M201.36,44.32V60.88a12.51,12.51,0,0,1,4.88-4.33,17.74,17.74,0,0,1,5-1.87,23.39,23.39,0,0,1,3.51-.28q6.49,0,10.48,3.72t4,10.51V92.17a.61.61,0,0,1-.69.69h-1.91a.61.61,0,0,1-.69-.69V68.93a12,12,0,0,0-2.8-8.05q-2.81-3.27-9.29-3.28a13.36,13.36,0,0,0-6.07,1.85,19,19,0,0,0-6.37,5.9V92.17a.61.61,0,0,1-.69.69h-1.91a.61.61,0,0,1-.69-.69V44.32a.61.61,0,0,1,.69-.69h1.91A.61.61,0,0,1,201.36,44.32Z"
      />
      <path
        fill="#fff"
        d="M260.25,89.43a.72.72,0,0,1,.73.45l.38,2c0,.4-.15.65-.46.72a64.16,64.16,0,0,1-9.23.54q-17.14,0-17.14-17V70.8a23,23,0,0,1,.29-3.54,18.56,18.56,0,0,1,1.3-4.26,15.47,15.47,0,0,1,2.57-4.22,12.77,12.77,0,0,1,4.47-3.09,17.83,17.83,0,0,1,13.7.16,12.66,12.66,0,0,1,4.54,3.37,14.62,14.62,0,0,1,2.38,4.62,23.63,23.63,0,0,1,1.05,4.37,30.14,30.14,0,0,1,.19,3.47V75a.61.61,0,0,1-.68.69H237.93v1.33c.3,5.12,1.77,8.54,4.41,10.29S249.2,90,255,90A35.07,35.07,0,0,0,260.25,89.43ZM237.81,72.64h23.93q0-15-11.79-15a18.93,18.93,0,0,0-2.65.17,13.48,13.48,0,0,0-3.06,1,8.94,8.94,0,0,0-3.16,2.29,13.08,13.08,0,0,0-2.27,4.45A22.69,22.69,0,0,0,237.81,72.64Z"
      />
      <path
        fill="#fff"
        d="M270.38,75.84V71.76q0-8.13,4.27-12.75t11.84-4.61a48.41,48.41,0,0,1,8.62.64.67.67,0,0,1,.46.69l-.31,2.1c0,.31-.27.47-.8.5a42.1,42.1,0,0,0-6.18-.73q-14.62,0-14.62,15.72v1Q273.66,90,288.28,90a38,38,0,0,0,6.18-.69c.51,0,.78.16.8.46l.31,2.1a.73.73,0,0,1-.46.73,51.36,51.36,0,0,1-8.62.61q-7.61,0-11.85-4.6T270.38,75.84Z"
      />
      <path
        fill="#fff"
        d="M306.69,71l20.79,21.25c0,.41-.17.61-.53.61h-2.6a1.87,1.87,0,0,1-1.29-.46L304.21,73V92.17a.61.61,0,0,1-.69.69h-1.91a.61.61,0,0,1-.69-.69V44.32a.61.61,0,0,1,.69-.69h1.91a.61.61,0,0,1,.69.69V68.78L321.49,55.2a1.92,1.92,0,0,1,1.3-.46h3.28c.36,0,.55.2.57.61Z"
      />
      <path
        fill="#fff"
        d="M332.9,58.35q4.1-4,10.91-4t10.92,4q4.09,3.94,4.1,12.95v5q0,9-4.1,12.94t-10.92,3.93q-6.81,0-10.91-4T328.8,76.3v-5Q328.8,62.3,332.9,58.35Zm2.38,28.33a12.73,12.73,0,0,0,17.06,0q3.21-3.29,3.21-9.85v-6.1q0-6.57-3.21-9.85a12.73,12.73,0,0,0-17.06,0q-3.19,3.28-3.2,9.85v6.1Q332.08,83.4,335.28,86.68Z"
      />
      <path
        fill="#fff"
        d="M364.61,76.07V55.43a.6.6,0,0,1,.68-.69h1.87a.65.65,0,0,1,.73.69V78q0,6.56,3.81,9.25A16.2,16.2,0,0,0,381.24,90a44.57,44.57,0,0,0,6.22-.5,17.86,17.86,0,0,0,5-1.22V55.43a.61.61,0,0,1,.69-.69H395a.65.65,0,0,1,.73.69V90.84c0,.2-.8.5-2.39.9a50.35,50.35,0,0,1-5.93,1,54.84,54.84,0,0,1-6.38.42q-8.2,0-12.3-3.93T364.61,76.07Z"
      />
      <path
        fill="#fff"
        d="M412.63,44.32V54.74h8.92a.61.61,0,0,1,.69.69v1.79a.64.64,0,0,1-.69.72h-8.92V79.35a15,15,0,0,0,1.75,7.54A6.11,6.11,0,0,0,420.14,90l1.09,0,1,0c.41,0,.61.22.61.65v2a.55.55,0,0,1-.53.61c-.59,0-1.36.08-2.33.08q-10.65,0-10.65-13.59V57.94H401a.66.66,0,0,1-.73-.72V55.43c0-.46.24-.69.73-.69h8.35V48.86l.39-4.54q0-.69.72-.69h1.49A.61.61,0,0,1,412.63,44.32Z"
      />
      <rect fill="#faa71a" x="99.44" width="53.61" height="83.18" rx="9.82" ry="9.82" />
      <line fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" x1="113.16" x2="113.16" y2="83.18" />
      <rect
        fill="#faa71a"
        x="14.79"
        y="152.41"
        width="53.61"
        height="83.18"
        rx="9.09"
        ry="9.09"
        transform="translate(-152.41 235.59) rotate(-90)"
      />
      <line fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" y1="207.08" x2="83.18" y2="207.08" />
      <rect
        fill="#faa71a"
        x="25.16"
        y="65.31"
        width="53.61"
        height="83.18"
        rx="9.27"
        ry="9.27"
        transform="translate(-66.89 108.3) rotate(-64.75)"
      />
      <line fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" x1="8.77" y1="100.99" x2="84" y2="136.48" />
    </svg>
  );
};

export default LogoDrawer;
